"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("../../config/constants");

var _ConditionalComponent = _interopRequireDefault(require("../ConditionalComponent/ConditionalComponent"));

var _ProgressMeter = _interopRequireDefault(require("../ProgressMeter/ProgressMeter"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _generateId = require("../../utils/generateId");

var _function = require("../../utils/type-checks/function");

var _number = require("../../utils/type-checks/number");

var _setCustomError = _interopRequireDefault(require("../../utils/html-input-validation/setCustomError"));

var _react = _interopRequireWildcard(require("react"));

var _string = require("../../utils/type-checks/string");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormTextArea = function FormTextArea(props) {
  var autoComplete = props.autoComplete,
      className = props.className,
      cols = props.cols,
      disabled = props.disabled,
      hasProgressMeter = props.hasProgressMeter,
      label = props.label,
      maxLength = props.maxLength,
      minLength = props.minLength,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      onValidate = props.onValidate,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      required = props.required,
      rows = props.rows,
      validateOnChange = props.validateOnChange;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      id = _useState2[0],
      setId = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isInteractionStarted = _useState6[0],
      setIsInteractionStarted = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      progressMeterId = _useState8[0],
      setProgressMeterId = _useState8[1];

  var _useState9 = (0, _react.useState)(""),
      _useState10 = _slicedToArray(_useState9, 2),
      validationMessage = _useState10[0],
      setValidationMessage = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      validity = _useState12[0],
      setValidity = _useState12[1];

  var _useState13 = (0, _react.useState)((0, _string.isString)(props.value) ? props.value : ""),
      _useState14 = _slicedToArray(_useState13, 2),
      value = _useState14[0],
      setValue = _useState14[1];

  var componentRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);
  var cmpClassName = (0, _classnames.default)(_defineProperty({
    "cmp-form-text-area": true,
    "cmp-form-text-area--isActive": (0, _string.isStringOfLength)(value) || isFocused,
    "cmp-form-text-area--isFocused": isFocused,
    "cmp-form-text-area--isInvalid": isInteractionStarted && !(validity !== null && validity !== void 0 && validity.valid)
  }, className, (0, _string.isStringOfLength)(className)));
  (0, _react.useEffect)(function () {
    setId((0, _string.isStringOfLength)(props.id) ? props.id : (0, _generateId.generateId)());
  }, [props.id]);
  (0, _react.useEffect)(function () {
    setProgressMeterId((0, _string.isStringOfLength)(props.progressMeterId) ? props.progressMeterId : (0, _generateId.generateId)());
  }, [props.progressMeterId]);

  var handleBlur = function handleBlur(e) {
    setIsInteractionStarted(true);
    setIsFocused(false);
    handleValidation(e.target, e.type);
    (0, _function.isFunction)(onBlur) && onBlur(e, componentRef.current);
    setValidity(inputRef.current.validity);
    setValidationMessage(inputRef.current.validationMessage);
  };

  var handleChange = function handleChange(e) {
    var value = e.target.value;
    setValue(value);
    validateOnChange && setIsInteractionStarted(true);
    handleValidation(e.target, e.type);
    (0, _function.isFunction)(onChange) && onChange(e, componentRef.current);
    validateOnChange && setValidity(inputRef.current.validity);
    validateOnChange && setValidationMessage(inputRef.current.validationMessage);
  };

  var handleFocus = function handleFocus(e) {
    setIsFocused(true);
    (0, _function.isFunction)(onFocus) && onFocus(e, componentRef.current);
  };

  var handleValidation = function handleValidation(eventTarget, eventType) {
    var customHandlerErrorMessage = "";
    var customHandlerValid = true;
    var isBlurEvent = eventType === "blur";
    var isChangeEvent = eventType === "change";

    if ((0, _function.isFunction)(onValidate) && (isBlurEvent || isChangeEvent)) {
      var _onValidate = onValidate(eventTarget, componentRef.current),
          message = _onValidate.message,
          valid = _onValidate.valid;

      customHandlerValid = valid;

      if (!customHandlerValid) {
        customHandlerErrorMessage = message;
      }
    }

    (0, _setCustomError.default)(eventTarget, customHandlerErrorMessage);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: cmpClassName,
    ref: componentRef
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement("span", null, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "cmp-form-text-area__input-wrap"
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    "aria-describedby": progressMeterId,
    autoComplete: autoComplete,
    cols: (0, _number.isNumber)(cols) && cols > 0 ? cols : null,
    disabled: disabled,
    id: id,
    maxLength: (0, _number.isNumber)(maxLength) && maxLength > 0 ? maxLength : null,
    minLength: (0, _number.isNumber)(minLength) && minLength >= 0 ? minLength : null,
    name: name,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    placeholder: (0, _string.isStringOfLength)(placeholder) ? placeholder : null,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    rows: (0, _number.isNumber)(rows) && rows > 0 ? rows : null,
    value: value
  })), /*#__PURE__*/_react.default.createElement(_ConditionalComponent.default, {
    condition: (0, _number.isNumber)(maxLength) && maxLength > 0 && hasProgressMeter
  }, /*#__PURE__*/_react.default.createElement(_ProgressMeter.default, {
    current: value.length,
    description: "".concat(maxLength - value.length, " characters remaining."),
    id: progressMeterId,
    max: maxLength || 0,
    message: "".concat(value.length, " of ").concat(maxLength, " characters used.")
  })), /*#__PURE__*/_react.default.createElement(_ConditionalComponent.default, {
    condition: isInteractionStarted
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cmp-form-text-area__input-validity"
  }, validationMessage)));
}; // Define propTypes;


FormTextArea.propTypes = {
  /** autoComplete attribute value on input field, from allowed list */
  autoComplete: _propTypes.default.oneOf(_constants.ALLOWED_AUTOCOMPLETE_ATTR_VALUES),

  /** String to be added to className */
  className: _propTypes.default.string,

  /** visible width of the text control in average character widths */
  cols: _propTypes.default.number,

  /** disabled attribute flag for input field */
  disabled: _propTypes.default.bool,

  /** flag for display of a progress meter element */
  hasProgressMeter: _propTypes.default.bool,

  /** id attribute on input field */
  id: _propTypes.default.string,

  /** label element text */
  label: _propTypes.default.string.isRequired,

  /** maxLength attribute on input field */
  maxLength: _propTypes.default.number,

  /** minLength attribute on input field */
  minLength: _propTypes.default.number,

  /** name attribute on input field */
  name: _propTypes.default.string,

  /** blur event handler */
  onBlur: _propTypes.default.func,

  /** change event handler */
  onChange: _propTypes.default.func,

  /** focus event handler */
  onFocus: _propTypes.default.func,

  /** validate event handler, returns object with boolean 'valid' property and string 'message' property */
  onValidate: _propTypes.default.func,

  /** placeholder attribute for input field */
  placeholder: _propTypes.default.string,

  /** id attribute for progress meter */
  progressMeterId: _propTypes.default.string,

  /** readonly attribute flag for input field */
  readOnly: _propTypes.default.bool,

  /** required attribute flag for input field */
  required: _propTypes.default.bool,

  /** visible height of the text control */
  rows: _propTypes.default.number,

  /** flag for validation on change event */
  validateOnChange: _propTypes.default.bool,

  /** value attribute on input field, providing default value */
  value: _propTypes.default.string
}; // Define defaultProps;

FormTextArea.defaultProps = {
  autoComplete: "off",
  disabled: false,
  hasProgressMeter: false,
  validateOnChange: false
}; // Export component as default;

var _default = FormTextArea;
exports.default = _default;